import { all, fork, takeLatest, put, select } from 'redux-saga/effects';
import { modules } from 'veritone-redux-common';
const {
  user: { userIsAuthenticated, FETCH_USER_SUCCESS, logout: veritoneLogout },
  config: { getConfig }
} = modules;

import {
  selectRouteType,
  selectCurrentRoutePayload,
  ROUTE_AUTH,
  ROUTE_HOME,
  ROUTE_NO_ADMIN_PERMISSION
} from 'state/modules/routing';
import { LOG_OUT } from './actions';
import { getRoleApi, userLogoutApi } from '../../../helpers/userApi';
import constant from '../../../helpers/constant';
import { includes } from 'lodash';

function* redirectToNotFoundIfNotAdminPermissions() {
  const config = yield select(getConfig);
  const userRoles = yield getRoleApi(config.urlApi);
  let hasAdminPermission = false;
  const userManagementRoles = [
    constant.CUSTOMER_SERVICE,
    constant.ATTRIBUTE_ADMIN,
    constant.ATTRIBUTE_ALL_ACCESS
  ];

  for (let appIndex = 0, numApps = userRoles.length; appIndex < numApps; appIndex++) {
    const roleId = userRoles[appIndex].id;
    if (includes(userManagementRoles, roleId)) {
      hasAdminPermission = true;
    }
  }

  if (!hasAdminPermission) {
    yield put({ type: ROUTE_NO_ADMIN_PERMISSION });
  }
}

function* redirectAwayIfAlreadyAuthenticated() {
  if (yield select(userIsAuthenticated)) {
    yield put({ type: ROUTE_HOME });
  }
}

function* redirectAwayAfterUserLogin() {
  yield takeLatest(FETCH_USER_SUCCESS, function*() {
    const routeType = yield select(selectRouteType);
    const currentRoutePayload = yield select(selectCurrentRoutePayload);
    const { nextType, nextPayload } = currentRoutePayload.query || {};

    if (routeType === ROUTE_AUTH) {
      // look for redirect information in the query string, and send the user
      // to their original destination if it exists.
      const redirectType = nextType || ROUTE_HOME;
      let parsedNextPayload;
      try {
        parsedNextPayload = JSON.parse(nextPayload);
      } catch (e) {
         console.log(e)
      }
      
      yield put({ type: redirectType, payload: parsedNextPayload });
    }
  });
}

function* logout() {
  yield takeLatest(LOG_OUT, function*() {    
    const config = yield select(getConfig);
    yield userLogoutApi(config.urlApi);
    yield put(veritoneLogout());
  });
}

export function* logoutSaga() {
  yield all([
    fork(logout)
  ])
}

export function* loadAuthPage() {
  yield all([
    fork(redirectAwayIfAlreadyAuthenticated),
    fork(redirectAwayAfterUserLogin)
  ]);
}

export function* loadPermissionPage() {
  yield all([
    fork(redirectToNotFoundIfNotAdminPermissions)
  ])
}
